import type { CookingSplit } from "@recipevault/shared";

const CYCLE: Record<CookingSplit, CookingSplit> = {
  "70-30": "60-40",
  "60-40": "40-60",
  "40-60": "70-30",
};

export function nextSplit(current: CookingSplit): CookingSplit {
  return CYCLE[current];
}

function formatRatio(split: CookingSplit): string {
  return split.replace("-", "/");
}

export interface SplitDividerProps {
  split: CookingSplit;
  onCycle: () => void;
}

export function SplitDivider({ split, onCycle }: SplitDividerProps) {
  const ratio = formatRatio(split);

  return (
    <button
      type="button"
      aria-label={`Adjust split (currently ${ratio})`}
      onClick={onCycle}
      style={{
        minHeight: 48,
        minWidth: 48,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        background: "none",
        border: "none",
        padding: 0,
      }}
    >
      {ratio}
    </button>
  );
}
